import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-facture-client',
  templateUrl: './facture-client.component.html',
  styleUrls: ['./facture-client.component.scss']
})
export class FactureClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
